export default "__VITE_ASSET__DNUpy0lz__"